import "./App.css";
import Layout from "layout/index";
import { BrowserRouter as Router } from "react-router-dom";
import { I18nextProvider, useTranslation } from "react-i18next";
import { i18n1 } from "./i18/i18";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { Provider } from "react-redux";
import store from "./app/store";
import Alert from "common/Alert/Alert";
function App() {
  const queryClient = new QueryClient();
  const { i18n } = useTranslation();
  const handleLanguageSelect = (lang: string) => {
    i18n.changeLanguage(lang);
  };
  return (
    <div
      className={`App`}
      // dir={i18n.language === 'ur' || i18n.language === 'ar' ? "rtl" : "ltr"}
    >
      <Alert>
        <Provider store={store}>
          <QueryClientProvider client={queryClient}>
            <I18nextProvider i18n={i18n1}>
              <Router>
                <Layout handleLanguageSelect={handleLanguageSelect} />
              </Router>
            </I18nextProvider>
          </QueryClientProvider>
        </Provider>
      </Alert>
    </div>
  );
}
export default App;
